import { render, staticRenderFns } from "./YoutubeVideok.vue?vue&type=template&id=0d8eb82b&"
import script from "./YoutubeVideok.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports